type ConfigOptionType = {
  key: any,
  text: string
}
export const CHART_TYPE_CONFIG = [
  {
    key: 'line',
    text: 'dbi_download_modal_linechart_type'
  },
  {
    key: 'shadow',
    text: 'dbi_download_modal_shadowchart_type',
  },
];
export const CHART_SIZE_CONFIG: {[key: string]: ConfigOptionType[]} = {
  line:[
    { key: '1070*300', text: '1070 × 300' },
    { key: '330*230', text: '330 × 230' },
  ],
  shadow: [
    { key: '330*210', text: '330 × 210' },
    { key: '480*250', text: '480 × 250' },
  ]
}